
(function() {
  'use strict';

  function fixSingleOptionDropdowns() {
    // Find all variant selectors (selects and radio fieldsets)
    var selects = document.querySelectorAll('variant-selects select, variant-radios fieldset');

    selects.forEach(function(el) {
      if (el.tagName === 'SELECT') {
        // Count non-empty options
        var options = Array.from(el.options).filter(function(o) { return o.value !== ''; });
        if (options.length === 1) {
          // Replace with static text
          var wrapper = el.closest('.product-form__input') || el.parentNode;
          var label = wrapper.querySelector('label');
          var labelText = label ? label.textContent.trim() : '';
          var valueText = options[0].textContent.trim();

          // Hide the select, show static text
          el.style.display = 'none';
          var staticEl = document.createElement('span');
          staticEl.className = 'h24-static-variant';
          staticEl.style.cssText = 'font-size:0.875rem;color:var(--color-foreground);opacity:0.8;';
          staticEl.textContent = valueText;
          el.parentNode.insertBefore(staticEl, el.nextSibling);
        }
      } else if (el.tagName === 'FIELDSET') {
        // Radio buttons - check if only one option
        var radios = el.querySelectorAll('input[type="radio"]');
        if (radios.length === 1) {
          // Hide the radio, show static text
          var wrapper = el.closest('.product-form__input') || el;
          var legend = wrapper.querySelector('legend');
          var labelEl = el.querySelector('label');
          var valueText = labelEl ? labelEl.textContent.trim() : radios[0].value;

          // Hide radio inputs
          radios[0].parentNode.style.display = 'none';
          var staticEl = document.createElement('span');
          staticEl.className = 'h24-static-variant';
          staticEl.style.cssText = 'font-size:0.875rem;color:var(--color-foreground);opacity:0.8;';
          staticEl.textContent = valueText;
          el.appendChild(staticEl);
        }
      }
    });
  }

  // Run on DOM ready and after Shopify section rendering
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSingleOptionDropdowns);
  } else {
    fixSingleOptionDropdowns();
  }

  // Also observe for dynamic content changes (Shopify sections)
  document.addEventListener('shopify:section:load', fixSingleOptionDropdowns);
})();
